function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6075",
  "data-name": "Group 6075",
  transform: "translate(-162.65 -106.332)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Worker_3856238",
  transform: "translate(147.65 106.336)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3409",
  "data-name": "Path 3409",
  d: "M70.815,65.926C57.234,65.926,46.185,54.3,46.185,40H41c0,17.155,13.375,31.112,29.815,31.112S100.631,57.155,100.631,40H95.445C95.445,54.3,84.4,65.926,70.815,65.926Z",
  transform: "translate(7.704 11.854)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3410",
  "data-name": "Path 3410",
  d: "M39.593,46.669h64.816A2.593,2.593,0,0,0,107,44.076V36.609a2.6,2.6,0,0,0-.823-1.9l-2.07-1.933A29.626,29.626,0,0,0,87.023,6.726V5.5a5.776,5.776,0,0,0-6-5.5H62.982a5.78,5.78,0,0,0-6.005,5.508V6.738A29.641,29.641,0,0,0,39.894,32.78l-2.071,1.934a2.6,2.6,0,0,0-.823,1.9v7.467a2.593,2.593,0,0,0,2.593,2.593ZM72,20.742a2.593,2.593,0,1,1-2.593,2.593A2.593,2.593,0,0,1,72,20.742ZM42.185,37.735l2.063-1.927a2.594,2.594,0,0,0,.818-2.053,24.417,24.417,0,0,1,15.5-22.936,2.594,2.594,0,0,0,1.6-2.4l0-2.894a.957.957,0,0,1,.823-.343h6.426V16.01a7.778,7.778,0,1,0,5.185,0V5.186H81.02a1,1,0,0,1,.817.318V8.412a2.593,2.593,0,0,0,1.6,2.395,24.159,24.159,0,0,1,15.5,22.946,2.593,2.593,0,0,0,.818,2.055l2.063,1.927v3.748H42.185Z",
  transform: "translate(6.519)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3411",
  "data-name": "Path 3411",
  d: "M22.778,141.779a2.6,2.6,0,0,1-2.593-2.593V89.4c0-3.031,3.152-6.744,6.006-8.094L48.7,73.161V87.334H53.89s.029-15.877,0-16.032L58.28,69.7,71.025,87.334h6.4L61.338,65.075a2.6,2.6,0,0,0-2.984-.92L24.319,76.472q-.1.036-.2.08C19.639,78.6,15,83.97,15,89.4v49.783a7.786,7.786,0,0,0,7.778,7.778h14.97a15.483,15.483,0,0,1-3.117-5.185Z",
  transform: "translate(0 18.966)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3412",
  "data-name": "Path 3412",
  d: "M118.145,76.552q-.1-.044-.2-.08L83.915,64.154a2.6,2.6,0,0,0-2.984.92L64.848,87.334h6.4L83.989,69.7,88.427,71.3c-.029.155-.048,16.032-.048,16.032h5.185V73.161l22.513,8.147c2.854,1.351,6.006,5.064,6.006,8.094v49.783a2.6,2.6,0,0,1-2.593,2.593H107.638a15.483,15.483,0,0,1-3.117,5.185h14.97a7.786,7.786,0,0,0,7.778-7.778V89.4C127.268,83.97,122.629,78.6,118.145,76.552Z",
  transform: "translate(14.771 18.966)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3413",
  "data-name": "Path 3413",
  d: "M119.625,88.764A7.865,7.865,0,0,0,113.5,86H35.848a7.626,7.626,0,0,0-7.68,9.324l7.1,36.778a10.565,10.565,0,0,0,10.09,8.344h58.634a10.565,10.565,0,0,0,10.09-8.344l7.1-36.778a7.891,7.891,0,0,0-1.556-6.56Zm-3.536,5.578-7.1,36.778a5.38,5.38,0,0,1-5,4.141H45.357a5.38,5.38,0,0,1-5-4.141s-7.078-36.67-7.1-36.778a2.532,2.532,0,0,1,2.588-3.156H113.5a2.517,2.517,0,0,1,2.588,3.156Z",
  transform: "translate(3.845 25.483)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_262",
  "data-name": "Ellipse 262",
  cx: 2.593,
  cy: 2.593,
  r: 2.593,
  transform: "translate(75.927 136.114)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251",
  transform: "translate(287.068 192.979)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398",
  "data-name": "Path 3398",
  d: "M72.281,25.242a1.642,1.642,0,0,0-.468-1.149L52.982,4.893A1.642,1.642,0,0,0,51.808,4.4H23.489a8.209,8.209,0,0,0-8.209,8.209v58.47a8.209,8.209,0,0,0,8.209,8.209H64.072a8.209,8.209,0,0,0,8.209-8.209ZM53.319,9.908l14.193,14.48H55.781a2.463,2.463,0,0,1-2.463-2.463ZM64.072,76H23.489a4.925,4.925,0,0,1-4.925-4.925V12.584a4.925,4.925,0,0,1,4.925-4.925H50.035V21.925a5.746,5.746,0,0,0,5.746,5.746H69V71.079A4.925,4.925,0,0,1,64.072,76Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399",
  "data-name": "Path 3399",
  d: "M64.314,48.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -7.857)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400",
  "data-name": "Path 3400",
  d: "M29.963,47.26a2.463,2.463,0,1,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -7.678)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401",
  "data-name": "Path 3401",
  d: "M64.314,61.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -10.186)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402",
  "data-name": "Path 3402",
  d: "M29.963,60.26a2.463,2.463,0,1,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -10.006)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403",
  "data-name": "Path 3403",
  d: "M64.314,74.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -12.514)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404",
  "data-name": "Path 3404",
  d: "M29.963,73.26a2.463,2.463,0,0,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -12.335)"
})));

function SvgStepper1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.699,
    height: 165.934,
    viewBox: "0 0 196.699 165.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper1);
export default __webpack_public_path__ + "static/media/stepper1.f00f37acc26df80af4bfff486db3b706.svg";
export { ForwardRef as ReactComponent };